import moment from 'moment';

type ParsedRRule = {
  frequency: string;
  dayOfWeek?: string;
  interval?: number;
  weekNumberInMonth?: number;
  stopEventDate?: Date | null;
  selectedOption?: number | null;
};

export const parseRRule = (rrule: string): ParsedRRule | null => {
  // Remove the 'RRULE:' prefix
  if (rrule?.startsWith('RRULE:')) {
    rrule = rrule?.slice(6);
  }

  // Initialize an empty object to store the parsed values
  const parsed: ParsedRRule = {
    frequency: '',
  };

  // Split the RRULE string by semicolons to get each part
  const parts = rrule?.split(';');

  // Iterate through the parts to extract values
  parts?.forEach((part) => {
    const [key, value] = part.split('=');

    switch (key) {
      case 'FREQ':
        parsed.frequency = value;
        break;

      case 'BYDAY':
        parsed.dayOfWeek = value;
        break;

      case 'INTERVAL':
        parsed.interval = parseInt(value, 10);
        break;

      case 'UNTIL':
        // Convert UNTIL value into a Date object
        parsed.stopEventDate = moment(value, 'YYYYMMDDTHHmmss').toDate();
        break;

      case 'BYMONTHDAY':
        // Handle BYMONTHDAY if needed
        break;

      case 'COUNT':
        // Handle COUNT if needed
        break;

      default:
        break;
    }
  });

  // If frequency is missing, return null
  if (!parsed.frequency) {
    return null;
  }

  // Handle frequency-specific details
  if (parsed.frequency === 'MONTHLY' && parsed.dayOfWeek) {
    const match = parsed.dayOfWeek.match(/^(\+?\d)([A-Za-z]+)$/);

    if (match) {
      parsed.weekNumberInMonth = parseInt(match[1], 10);
      parsed.dayOfWeek = match[2].toUpperCase();
      parsed.frequency = 'monthly_on_selected_day';
    }
  } else if (
    parsed.frequency === 'WEEKLY' &&
    parsed.dayOfWeek &&
    parsed.interval &&
    parsed.interval > 1
  ) {
    parsed.frequency = 'every_interval_week_on';
  } else if (parsed.frequency === 'WEEKLY' && parsed.dayOfWeek) {
    parsed.frequency = 'weekly';
  } else if (parsed.frequency === 'DAILY') {
    parsed.frequency = 'daily';
  } else if (parsed.frequency === 'YEARLY') {
    const monthMatch = rrule.match(/BYMONTH=(\d+)/);
    const dayMatch = rrule.match(/BYMONTHDAY=(\d+)/);

    if (monthMatch && dayMatch) {
      parsed.frequency = 'annually_on_month_day';
      parsed.dayOfWeek = `${monthMatch[1]}-${dayMatch[1]}`;
    }
  }

  return parsed;
};
